export default __webpack_public_path__ + "static/media/ic_tajikistan.ce518058.svg";